import React from 'react'
import { RESPONSIBILITY } from '@trustero/trustero-api-web/lib/common/model_pb'
import { Control } from '@trustero/trustero-api-web/lib/model/control_pb'
import { Tooltip } from '../Tooltip'
import { TooltipOverlayType, TooltipPositions } from '../Tooltip/Tooltip'
import { FlexAlign, FlexRow } from '../Flex'
import { PolicyWarningIcon, PolicyIcon, PolicyTitle } from './ListItem.styles'
import { LIST_ITEM_COPY } from './ListItem.constants'

export const PolicyInfo = ({
  policyName,
  isWarning,
  policyNaMismatch,
  isLarge,
}: {
  policyName: string
  isWarning: boolean
  policyNaMismatch?: boolean
  isLarge?: boolean
}): JSX.Element => {
  const icon = isWarning ? (
    <PolicyWarningIcon $isLarge={isLarge} />
  ) : (
    <PolicyIcon $isLarge={isLarge} />
  )

  return (
    <Tooltip
      id={`controls-index-row-policy-tooltip-${policyName}`}
      placement={TooltipPositions.top}
      overlayType={TooltipOverlayType.popover}
      tooltipBody={
        policyNaMismatch
          ? `This control's policy is marked not applicable, but the control is not.`
          : ''
      }
      disabled={!policyNaMismatch}
    >
      <FlexRow align={FlexAlign.CENTER} justify={FlexAlign.FLEX_START} gap={4}>
        {icon}
        <PolicyTitle $isLarge={isLarge}>{policyName}</PolicyTitle>
      </FlexRow>
    </Tooltip>
  )
}

export const ControlPolicyInfo = ({
  control,
  isControlNa,
  isLarge,
}: {
  control?: Control.AsObject
  isControlNa: boolean
  isLarge?: boolean
}): JSX.Element => {
  const isPolicyNa = control?.responsibility === RESPONSIBILITY.NOT_APPLICABLE
  const policyNaMismatch = isPolicyNa && !isControlNa
  const policyName = policyNaMismatch
    ? LIST_ITEM_COPY.NOT_APPLICABLE_POLICY
    : control?.policyName || LIST_ITEM_COPY.NO_POLICY
  const isWarning = policyNaMismatch || !control?.policyName

  return (
    <PolicyInfo
      policyName={policyName}
      isWarning={isWarning}
      policyNaMismatch={policyNaMismatch}
      isLarge={isLarge}
    />
  )
}
